export default {
  setUsers(state, payload) {
    state.users = payload;
  },
  addUser(state, payload) {
    state.users.unshift(payload);
  },
  updateUser(state, payload) {
    const index = state.users.findIndex(
      item => item.username === payload.username
    );
    if (index !== -1) {
      // Merge — a full replace dropped every field not in the hand-built
      // payload (id, upiid, is_deleted, balance, …), corrupting the row
      // for any later edit that reads back from it.
      state.users[index] = { ...state.users[index], ...payload };
    }
  },
  deleteUser(state, username) {
    const index = state.users.findIndex(item => item.username === username);
    state.users.splice(index, 1);
  },
  changeUserStatus(state, payload) {
    const index = state.users.findIndex(
      item => item.username === payload.username
    );
    if (index !== -1) {
      // Normalize boolean (from base-toggle) and number callers to 0/1 so the
      // status filter `user.status === 1` keeps working without a reload.
      state.users[index].status = payload.status ? 1 : 0;
    }
  }
};
